import {useContext} from 'react';

import useIsMobile from '@/src/hooks/useIsMobile';
import ArchivePositionsRowLayout from '@/src/jobPortal/clinicPositions/components/ArchivePositionsRowLayout';
import EmptyDataWithLink from '@/src/jobPortal/clinicPositions/components/EmptyDataWithLink';
import {
  DUPLICATE_PARAM,
  NEW_POSITION,
} from '@/src/jobPortal/common/containers/SinglePositionBootstrap';
import RouteContext from '@/src/routes/utils/RouteContext';
import TextLocal from '@/src/textLocal/containers/TextLocal';

import css from '../styles/ActiveJobPositionsLayout.module.css';

interface ArchiveJobPositionsLayoutProps {
  data: Array<any>;
  isLoading?: boolean;
  onDeleteClick: Function;
}

const ArchiveJobPositionsLayout = ({
  data,
  isLoading,
  onDeleteClick,
}: ArchiveJobPositionsLayoutProps) => {
  // @ts-ignore
  const {JOB_PORTAL_MY_POSITION_EDIT} = useContext(RouteContext);
  const {isMaxWidth900} = useIsMobile();

  if (!data.length && !isLoading) {
    return <EmptyDataWithLink />;
  }

  return (
    <div>
      <table className={css.tableWithAction}>
        <tbody>
          {isMaxWidth900 ? (
            <tr className={css.tableHeader}>
              <th>
                <TextLocal id={'tables.name'} />
              </th>
              <th>
                <TextLocal id={'tables.applies-viewed'} />
              </th>
              <th>
                <TextLocal id={'tables.actions'} />
              </th>
            </tr>
          ) : (
            <tr className={css.tableHeader}>
              <th>
                <TextLocal id={'tables.name'} />
              </th>
              <th>
                <TextLocal id={'tables.viewed'} />
              </th>
              <th>
                <TextLocal id={'tables.applies'} />
              </th>
              <th>
                <TextLocal id={'tables.actions'} />
              </th>
            </tr>
          )}

          {data.map((position) => (
            <ArchivePositionsRowLayout
              isMobile={isMaxWidth900}
              key={position.id}
              id={position.id}
              title={position.title}
              onDeleteClick={() => {
                onDeleteClick(position.id, position.title);
              }}
              archivedAt={position.archived_at}
              expiredAt={position.expire_date}
              editLink={`${JOB_PORTAL_MY_POSITION_EDIT.getLink(
                NEW_POSITION
              )}?${DUPLICATE_PARAM}=${position.id}`}
              vacancyApplicationsCount={position.vacancy_applications_count}
              status={position.status}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ArchiveJobPositionsLayout;
